import React, {Component} from 'react'
import {message} from 'antd/lib/index'
import StatementsApi from '../../../api/Finance/Statements'
import Statements from './Statements'
import {isEmpty, omit, pick} from 'lodash'
import {dateVal} from '../../../modules/Utils'

class StatementsCont extends Component {
  state = {
    list: [],
    statement: {},
    fetching: false,
    visible: false,
    visibleCSV: false,
    submitting: false,
  }
  api = new StatementsApi()
  formRef = React.createRef()

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const cached = await this.api.list()
      let list = cached
      if (!isEmpty(this.state.company))
        list = cached.filter(i => i.company._id === this.state.company)
      this.setState({
        fetching: false,
        list,
        cached,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }
  fetchStatement = async key => {
    try {
      this.setState({
        visible: true,
        type: 'edit',
        fetchingStatement: true,
      })
      const statement = await this.api.read(key)
      statement.date = dateVal(statement, 'date')
      statement.period = [
        dateVal(statement, 'period.start'),
        dateVal(statement, 'period.end'),
      ]
      this.setState({
        fetchingStatement: false,
        statement,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetchingStatement: false, visible: false})
    }
  }
  onShow = async e => {
    this.setState({
      visible: true,
      statement: {},
      type: 'new',
    })
  }
  onShowCSVModal = async e => {
    this.setState({
      visibleCSV: true,
      statement: {},
      type: 'new',
    })
  }
  onCancel = () => {
    this.setState({
      visible: false,
      visibleCSV: false,
      statement: {},
    })
  }
  create = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      let {statement} = this.state
      statement.period = {
        start: statement.period[0],
        end: statement.period[1],
      }
      await this.api.create(statement)
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({submitting: false})
    }
  }
  update = async () => {
    await this.checkForm()
    try {
      this.setState({
        submitting: true,
      })
      let {statement} = this.state
      statement.period = {
        start: statement.period[0],
        end: statement.period[1],
      }
      await this.api.update(
        omit(statement, ['company', 'currency', 'code', 'status', '_history']),
      )
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({submitting: false})
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            statement: Object.assign({}, this.state.statement, values),
          })
          res(true)
        }
      })
    })
  }
  reject = async statement => {
    try {
      this.setState({
        fetching: true,
      })
      await this.api.operation(
        'reject',
        pick(statement, ['_id', '_key', '_rev']),
      )
      this.setState({
        fetching: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }
  remove = async () => {
    const statement = this.state.statement
    try {
      this.setState({
        removing: true,
      })
      await this.api.remove(pick(statement, ['_id', '_key', '_rev']))
      this.setState({
        removing: false,
      })
      await this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({removing: false})
    }
  }
  approve = async statement => {
    try {
      this.setState({
        fetching: true,
      })
      await this.api.operation(
        'approve',
        pick(statement, ['_id', '_key', '_rev']),
      )
      this.setState({
        fetching: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }
  submit = async statement => {
    try {
      this.setState({
        fetching: true,
      })
      await this.api.operation(
        'submit',
        pick(statement, ['_id', '_key', '_rev']),
      )
      this.setState({
        fetching: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }

  onEdit = async (e, statement) => {
    await this.fetchStatement(statement._key)
  }
  onChangeCompany = company => {
    this.filterCompany(company)
    this.setState({
      company,
    })
  }
  filterCompany = _id => {
    this.setState((prevState, props) => ({
      list: _id
        ? prevState.cached.filter(i => i.company._id === _id)
        : prevState.cached,
    }))
  }

  render() {
    return (
      <Statements
        {...this.state}
        {...pick(this, [
          'fetch',
          'onCancel',
          'onShow',
          'onEdit',
          'onChangeCompany',
          'filterCompany',
          'submit',
          'update',
          'create',
          'reject',
          'remove',
          'approve',
          'formRef',
        ])}
      />
    )
  }
}

StatementsCont.propTypes = {}
StatementsCont.defaultProps = {}

export default StatementsCont
